var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"container__contentbody",class:`min-w-[${_vm.minWidth}]`},[_c('div',{staticClass:"container__contentbody__slot",class:`min-w-[${_vm.minWidth}]`},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }